import { StyleSheet } from '@react-pdf/renderer';

export const sharedTableStyles = StyleSheet.create({
  address: {
    width: 110,
  },
  gla: {
    width: 50,
  },
  site: {
    width: 50,
  },
  saleDate: {
    width: 60,
  },
  salePrice: {
    width: 60,
  },
  term: {
    width: 80,
  },
  difference: {
    width: 100,
  },
});
